export const environment = {
  production: true,
  client: false,
  telestrationsBaseUrl: 'https://party-bee-telestrations.herokuapp.com',
  triviaBaseUrl: 'https://party-bee-trivia.herokuapp.com',
  liarsDiceBaseUrl: 'https://party-bee-liars-dice.herokuapp.com',
  scattergoriesBaseUrl: 'https://party-bee-scattergories.herokuapp.com'
};
